export const normalizeUrl = (value: string) => {
  try {
    const hasProtocol = /^https?:\/\//i.test(value);
    const url = new URL(hasProtocol ? value : `https://${value}`);
    return url.toString();
  } catch {
    return `https://${value}`;
  }
};

export const getDisplayDomain = (value: string): string | null => {
  try {
    const url = new URL(normalizeUrl(value));
    return url.hostname.replace(/^www\./, '') || null;
  } catch {
    return null;
  }
};

export const getFaviconUrl = (value: string) =>
  `https://www.google.com/s2/favicons?sz=32&domain_url=${encodeURIComponent(normalizeUrl(value))}`;
